module.exports = __webpack_public_path__ + "static/media/intro-celebration-plain.638cc84f.webp";